<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <div v-if="(disableAdvancedTransfer == false || disableAdvancedTransfersBeforeIsSigned == false) && !forwardCC && !hideTransferCC" class="apply-button text-end mx-6">
                <v-btn text class="p-0 btn-link" @click="multiTransferFormDialog=true">
                    {{ $t("res_Label_AdvancedTransfer") }}
                </v-btn>
            </div>
            <label v-if="numberOfAttachmentsRemainingToUpload !== 0" style="color: red !important; font-style: italic;">
                {{ $t('res_Msgs_transferMoreAttachmentError').replace('{0}', numberOfAttachmentsRemainingToUpload) }}
            </label>
            <div class="mb-3-rem" v-if="canSignByImpersonation && sign && constants.enableImpersonateSignatureInDelegation">
                <label v-for="option in SignAsOptions" :key="option.value" class="radio-label">
                    <input type="radio" :value="option.value" v-model="SelectedSignAsOption" class="radio-input">
                    {{ option.label }}
                </label>
            </div>
            <div class="mb-3-rem" v-if="sign && !isUAEPassEnabled && !isDocusignEnabled">
                <v-label>{{ $t("res_Label_PinValue") }}</v-label>
                <div class="d-flex gap-2">
                    <v-text-field :readonly="pinValidate" @keyup.enter="pinValidate" v-model="pinCode" solo
                        type="password"></v-text-field>
                    <v-btn class="small icon" :disabled="pinValidate" @click="ValidatePin">
                        <v-icon class="custom-icon">mdi-check-ring</v-icon>
                    </v-btn>
                </div>
            </div>

            <div class="mb-3-rem" v-if="canSendSecretTransfer && !hideTransferCC">
                <v-label>{{ $t("res_Label_SecretForward") }}</v-label>
                <v-checkbox :readonly="!pinValidate" style="margin: 0px;" v-model="secretForward">
                </v-checkbox>
            </div>

            <div class="mb-3-rem" v-if="transferToMulti.length == 0 && !hideTransferCC">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label> 

                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="categoryId == 2 && canBeSignedByExternalUser"
                    :showInternalStructures="true" :ignorePermissions="categoryId !== 3"
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="false" :selectedStructureUser="transferTo"
                    @structureUserSelectChanged="transferToSelectedChange"
                    :disabled="(!pinValidate || disableRecipient) && (!isUAEPassEnabled && !isDocusignEnabled)" 
		    :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                    :hideStructureWithDisableTransfer="true" :calledFromField="('CalledFromTransfer')" >
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem" v-if="transferToMulti.length > 0 && !hideTransferCC">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true" :showExternalStructures="false"
                    :excludeSelf="true" :isMultiple="true"
                    :selectedStructureUsersList="transferToMulti"
                    @structureUserSelectChanged="transferToMultipleSelectedChange"
                    :disabled="(!pinValidate || disableRecipient)
		    &&(!isUAEPassEnabled && !isDocusignEnabled)" 
		   
		     :addressBook_header="$t('res_Label_SelectStructureOrUser')" :calledFromField="('CalledFromTransfer')">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem" v-if="Forwarded">
                <v-list>
                    <v-list-item v-for="item in Forwarded" :key="item">
                        <v-list-item-content>
                            <v-list-item-title v-text="item"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>

            <div class="mb-3-rem" v-if="!forwardCC ">
                <v-label>{{ $t("res_Label_CC") }}</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false" showAllInternal="true"
                    :showInternalStructures="true" 
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="true" :selectedStructureUsersList="transferCC"
                    @structureUserSelectChanged="ccSelectedChange"
                    :disabled="(!pinValidate || disableRecipient) 
		    
		     && (!isUAEPassEnabled && !isDocusignEnabled)"
                 
		    :addressBook_header="$t('res_Label_SelectStructureOrUser')" :calledFromField="('CalledFromTransfer')" 
            :ignorePermissions="this.categoryId !== 3">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem">
                <div class="d-flex gap-4">
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_Purpose") }}</v-label>
                        <multiselect :disabled="(!pinValidate || forwardCC  || readOnlyPurpose) 
			&& (!isUAEPassEnabled && !isDocusignEnabled)"
		
			class="light-bg add-arrow" v-model="purpose"
                            label="name" track-by="id" open-direction="bottom" :options="purpose_items"
                            :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                            :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                            :hide-selected="false" :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')" @input="handleSelectionChange">
                            
                        </multiselect>
                    </div>
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_DueDate") }}</v-label>
                        <v-menu content-class="p-0" v-model="transfer_date_menu" :close-on-content-click="false"
                            transition="scale-transition" offset-y left min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :readonly="(!pinValidate)
				 && (!isUAEPassEnabled && !isDocusignEnabled)" 
				 :value="utils.dateFormat(dueDate)" label=""
                                    v-bind="attrs" v-on="on" solo append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker :readonly="!pinValidate" v-model="dueDate" @input="transfer_date_menu = false"
                                :min="nowDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </div>

            <div class="pt-2" style="margin-bottom: 23px; line-height: 0">
                <v-label>{{ $t("res_Label_Note") }}</v-label>
                <textarea class="text-area" :readonly="!pinValidate && (!isUAEPassEnabled && !isDocusignEnabled)" 
		
		 style="height:100px" v-model="note"></textarea>
            </div>
            <div class="mb-3-rem">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-checkbox :readonly="!pinValidate && (!isUAEPassEnabled && !isDocusignEnabled)" class="m-0 p-0" v-model="followup"></v-checkbox>
                        <label class="checkbox-label">{{ $t("res_Label_NeedFollowUp") }}</label>
                    </div>
                    <div class="d-flex align-center">
                        <v-checkbox :readonly="!pinValidate && (!isUAEPassEnabled && !isDocusignEnabled)" class="m-0 p-0" v-model="isSecretNote"></v-checkbox>
                        <label class="checkbox-label">{{ $t("res_Label_IsSecretNote") }}</label>
                    </div>
                </div>
            </div> 
        </div>

        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="cancelDialog">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            <v-btn v-if="!sign" class="primary flex-1" :disabled="(!pinValidate || numberOfAttachmentsRemainingToUpload !== 0) && (!isUAEPassEnabled && !isDocusignEnabled)"
                @click="Send">{{ $t('res_ButtonText_Continue') }}
            </v-btn>
            <v-btn v-if="sign && !rejected" class="light-success  flex-1" style="color: #009639 !important;"   :disabled="(!pinValidate || numberOfAttachmentsRemainingToUpload !== 0) && (!isUAEPassEnabled && !isDocusignEnabled)" @click="Send">
                <v-icon class="custom-icon" >mdi-check-ring</v-icon>&nbsp;{{ $t("res_ButtonText_SignAndSend") }}
            </v-btn>
            <v-btn v-if="sign && rejected" class="danger  flex-1"  style="color: #ea0000 !important;"    :disabled="(!pinValidate || numberOfAttachmentsRemainingToUpload !== 0) && (!isUAEPassEnabled && !isDocusignEnabled)" @click="Send">
                <v-icon class="custom-icon">mdi-close-circle</v-icon>{{ $t("res_ButtonText_Reject") }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="selectSignMethodFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <SignSelectSignMethod :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                                              @closeSignMethodSelectAndOpenSignWithPin="closeSignMethodSelectAndOpenSignWithPin"
                                              @closeSelectSignMethodFormDialog="closeSelectSignMethodFormDialog"
                                              @closeSignFormDialog="closeSignFormDialog"
                                              :isSignAndSend="isSignAndSend" :hasBeenSignedWithUAEPass="hasBeenSignedWithUAEPass"
                                              :isUAEPassEnabledForTemplate="isUAEPassEnabledForTemplate || documentByFile"
                                              :isEsealEnabledForTemplate="isEsealEnabledForTemplate"
                                              @uaeDocumentSigned="transfer" />
                    </div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="signFormDialog" :persistent="true" content-class="small-dialog" width="650" height="750">
                <v-card>
                    <v-card-title>
                        {{ $t("res_CardHeaders_Sign") }}
                    </v-card-title>
                    <div style="overflow: hidden">
                        <Sign :propertyBag="propertyBag" :dialogModelShow="signFormDialog"
                              :isSignAndSend="isSignAndSend"
                              @uaeDocumentSigned="transfer" 
                              @closeSignFormDialog="closeSignFormDialog" />
                    </div>
                </v-card>
            </v-dialog>
        <v-dialog v-model="multiTransferFormDialog" content-class="dialog with-fixed-actions bg-white" fullscreen scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
                        {{ $t("res_Label_AdvancedTransfer") }}
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <div class="custom-icon-wrapper">
                        <v-icon @click="multiTransferFormDialog = false">custom-icon mdi-close</v-icon>
                    </div>
                </v-toolbar>
               <MultiTransferForm @closeMultiTransferForm="closeMultiTransferForm" :documentId="documentId" :transferId="transferId" :followup="followup"
               :categoryId="categoryId" :canBeSignedByExternalUser="canBeSignedByExternalUser">
                </MultiTransferForm>
          
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import { McWysiwyg } from '@mycure/vue-wysiwyg'
import SignSelectSignMethod from '@/components/SelectSignMethod.vue'
import { mapGetters } from 'vuex'
import debounce from "lodash.debounce"
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import MultiTransferForm from '@/components/MultiTransferForm.vue'
import Sign from '@/components/Sign.vue'
//import * as docActions from '@/assets/js/documentActions.js'

export default {
    name: 'TransferForm',
    components: { Multiselect, SignSelectSignMethod, Sign, McWysiwyg, StructureUserSelector, MultiTransferForm },
    data() {
        return {
            propertyBag:{},
            language: '',
            dueDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
            loading: false,
            structures: [],
            transferDate: '',
            CCstructures: [],
            purpose_items: [],
            Forwarded: [],
            pinCode: '',
            pinValidate: !this.sign,
            transfer_date_menu: false,
            note: '',
            followup: false,
            secretForward: false,
            nowDate: new Date().toISOString().slice(0, 10),
            canSendSecretTransfer: constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.SecretTransfer.key),
            numberOfAttachmentsRemainingToUpload: 0,
            debouncedHandler1: null,
            debouncedHandler2: null,
            utils: utils,
            constants:constants,
            SignAsOptions: [{ label: 'On behalf', value: false }, { label: 'Impersonation', value: true}],
            SelectedSignAsOption: false ,
            canSignByImpersonation:false,
            multiTransferFormDialog: false,
            disableAdvancedTransfersBeforeIsSigned: window.disableAdvancedTransfersBeforeIsSigned,
            isSecretNote: false,
            openSelectSignMethod:false,
            signFormDialog:false,
            isSignAndSend:false,
            selectSignMethodFormDialog:false,
            isUAEPassEnabledForTemplate: false,
            isEsealEnabledForTemplate: false,
        }
    },
    props:
    {
        hideTransferCC: { type: Boolean, default: false },
        readOnlyPurpose: { type: Boolean, default: false },
        forwardCC: {type: Boolean, dafault: false },
        workflowId: { type: Number, default: 0 },
        rejected: { type: Boolean, default: false },
        disableRecipient: { type: Boolean, default: false },
        transferId: { type: String, default: '0' },
        documentId: { type: String, default: '0' },
        transferTo: { type: Object, default: {} },
        transferToMulti: { type: Array, default: [] },
        successMessage: { type: String, default: 'res_Msgs_DocumentSignedAndSent' },
        transferCC: { type: Array, default: [] },
        purpose: { type: Object, default: {} },
        sign: { type: Boolean, default: false },
        delegationId: { type: Number, default: 0 },
        transferFormDialog: { type: Boolean, default: false },
        checkForAttachmentsUploadMultiApproval: { type: Boolean, default: false },
        defaultDueDate: { type: String, default: "" },
        disableAdvancedTransfer:{ type: Boolean, default: false },
        transferFormType: { type: String, default: 'Transfer' },
        hasBeenSignedWithUAEPass: { type: Boolean, default: false },
        documentCreatedByUserId: { type: Number, default: 0 },
        categoryId:{ type: Number, default: 0 },
        mom_purpose_items: [],
        isUAEPassEnabled: { type: Boolean, default: false },
        isDocusignEnabled: { type: Boolean, default: false },
        documentByFile: { type: Boolean, default: false },
        canBeSignedByExternalUser: {type: Boolean, default: false}
    },
    beforeMount() 
    {
        this.debouncedHandler1 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.structures = res.data)
                .catch(err => console.log(err));
        }, 200);

        this.debouncedHandler2 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.CCstructures = res.data)
                .catch(err => console.log(err));
        }, 200);
    },
    methods:
    {
         GetInitiator(documentId) {
                utils.defaultGet('Transfer/GetInitiator?documentId=' + documentId,
                    (res) => {
                        console.log("GetInitiator2"+res)
                        if (res.data != null && res.data != undefined && res.data.id != null && res.data.id != undefined) {
                            this.transferTo = res.data
                        }
                    }, this.handleError, true);
            },
         handleSelectionChange(selectedValue) 
         {
          if(this.categoryId==6)
           {        
            if( selectedValue.name=='For Signature'){
            // Call any other methods or perform any actions based on selectedValue.
                this.getNextReceiver(false,false,false,selectedValue.name) 
            }
            //else if( (selectedValue.name=='Approved'|| selectedValue.name=='Rejected') && this.transferId!=0 &&this.transferId!=null ){
              //   this.GetInitiator(this.documentId)
            //}
            else if( selectedValue.name=='For Review'){  this.getNextReceiver(false,false,false,null)}
            }
         }
      ,    getNextReceiver(isSign, isEndorse, isRejected,purpose) { 
                this.transferCC = []
                this.transferTo = {};
                this.transferToMulti = []

                utils.defaultGet('Transfer/GetDocumentNextDefaultReceiver?docId=' + this.documentId + '&isSign=' + isSign + '&isEndorse=' + isEndorse +
                 '&delegationId=' + this.delegationId+'&purpose='+purpose,
                    (res) => {
                        if (res.data != null && res.data != undefined) {
                            if (res.data.length > 0 && res.data[0].id != 0) {
                                var isMultiForwardEnabled = false
                                var notCcedElements = res.data.filter(x => x.isCced == false)
                                if (notCcedElements.length > 1)
                                    isMultiForwardEnabled = true
                                res.data.forEach(element => {
                                    
                                    if (element.isCced)
                                        this.transferCC.push(element)
                                    else {
                                        if (element.name != "0") {
                                            if (isMultiForwardEnabled == false)
                                                this.transferTo = element
                                            else
                                                this.transferToMulti.push(element)
                                        }
                                    }
                                });
                                if (this.transferCC.length > 0) {
                                    this.transferCC = this.handleFirstElement(this.transferCC, {});
                                }

                                if (this.transferToMulti.length > 0) {
                                    this.transferToMulti = this.handleFirstElement(this.transferToMulti, { name: 'temp', isTemp: true });
                                } else {
                                    this.transferToMulti = []
                                }

                            }
                        }
                    }, this.handleError, true);
            }
      ,
        closeSignFormDialog() 
        {
            this.signFormDialog = false
        },
        closeSelectSignMethodFormDialog() 
        {
            this.selectSignMethodFormDialog = false
        },
        closeSignMethodSelectAndOpenSignWithPin() 
        {
            this.selectSignMethodFormDialog = false
            this.selectSignMethodFormDialog = false
            this.signFormDialog = true
        },
        openSelectSignMethodDialog()
        {
            this.isSignAndSend = true;
            this.propertyBag.documentId = this.documentId
            this.propertyBag.transferId = this.transferId
            this.propertyBag.delegationId = this.delegationId
            this.selectSignMethodFormDialog = true
        },
        openMultiSelectCtrl(id) 
        {
            if (id === 1) this.$refs.multiselect1.activate()
        },
        ValidatePin() 
        {
            if (this.pinCode == '') 
            {
                window.showAlert('res_Msgs_EnterPin', 'warning')
            }
            else
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.delegationId)
                    .then(res => 
                    {
                        if (res.data == 'SignaturePinNotSet')
                            window.showAlert('res_Msgs_PinNotSet', 'warning')

                        else if (res.data == 'NoDefaultSignatureFound')
                            window.showAlert('res_Msgs_NoDefaultSignature', 'warning')

                        else 
                        {
                            axios.get(constants.baseApiUrl + 'Document/CheckHasValidPin?pinValue=' + this.pinCode)
                                .then(res => 
                                {
                                    if (res.data == false) 
                                    {
                                        window.showAlert('res_Msgs_InvalidPin', 'error')
                                        this.pinValidate = false
                                    }
                                    else
                                        this.pinValidate = true
                                })
                                .catch(error => { console.log(error); window.hideLoading(); })
                        }
                    })
                    .catch(err => window.showAlert(err, 'error'))
                    .finally(() => window.hideLoading())
            }
        },
        removeToItem(itemId) 
        {
            this.transferTo = this.transferTo.filter(item => item.id !== itemId);
        },
        removeCCItem(itemId) 
        {
            this.transferCC = this.transferCC.filter(item => item.id !== itemId);
        },
        CapitalizeFirstLetter(str) 
        {
            return utils.CapitalizeFirstLetter(str);
        },
        GetMultiSelectSubHeaderDisplay(options) 
        {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        asyncFindTransferToStructure(query) 
        {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => 
                {
                    this.structures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        asyncFindTransferCCStructure(query) 
        {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => 
                {
                    this.CCstructures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        Send() 
        {
            window.showLoading()

            if (this.sign && !this.rejected && (this.isUAEPassEnabled || this.isDocusignEnabled))
            {
                if ((this.transferTo != null && this.transferTo != undefined && this.transferTo != '' && this.transferTo.id != null && this.transferTo.id != undefined && this.transferTo.id != '')
                    || (this.transferToMulti != null && this.transferToMulti != undefined && this.transferToMulti.length >1)) 
                {
                    if (this.purpose == null || this.purpose == undefined || this.purpose == '' || this.purpose.id == null || this.purpose.id == undefined || this.purpose.id == '') 
                    { 
                        window.hideLoading()
                        window.showAlert('res_Msgs_FillRequired', 'warning')
                        return;
                    }
                    else
                    {
                        window.hideLoading()
                        this.openSelectSignMethodDialog()
                    }
                }
                else 
                {
                    window.hideLoading()
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }
            }
            else if (this.sign && !this.rejected ) 
            {
                axios.post(constants.baseApiUrl + 'Document/SignDocument?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.delegationId+'&impersonatedSignature='+this.SelectedSignAsOption+'&enableRecipientsMultiPages='+this.constants.enableRecipientsMultiPages)
                    .then(res => { this.transfer() })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            }
            else if (this.rejected && this.sign) 
            {
                axios.post(constants.baseApiUrl + 'Document/RejectDocument?documentId=' + this.documentId + '&transferId=' + this.transferId + '&delegationId=' + this.delegationId+'&impersonatedSignature='+this.SelectedSignAsOption+'&enableRecipientsMultiPages='+this.constants.enableRecipientsMultiPages)
                    .then(res => { this.transfer() })
                    .catch(error => console.log(error))
                    .finally(() => window.hideLoading())
            }
            else
                this.transfer()
        },
        closeDialog() 
        {
            this.clearForm()
            this.$emit('closeTransformDialog');
        },
        async transfer() {
    try {
    
       var transferTos = [];
        window.showLoading();

        if (!this.hideTransferCC) {
            if (this.isValidTransfer()) {
                if (!this.purpose || !this.purpose.id) {
                    this.showWarning('res_Msgs_FillRequired');
                    return;
                }

              //  const transferTos = this.getTransferTos();
	            var transferTos = [];
                if (this.transferTo != null && this.transferTo != undefined && this.transferTo != '' && this.transferTo.id != null && this.transferTo.id != undefined && this.transferTo.id != '')
                    transferTos.push(this.transferTo);
                else
                    transferTos = this.transferToMulti.filter(item => item !== this.transferToMulti[0]);

                const transferCCs = this.getTransferCCs();

                const params = this.buildParams(transferTos, transferCCs);
                await this.sendTransferRequest(params);
            } else {
                this.showWarning('res_Msgs_FillRequired');
            }
        } else {
            const transferCCs = this.getTransferCCs();

            if (transferCCs.length === 0) {
                this.showWarning('res_Msgs_FillRequired');
                return;
            }

            const params = this.buildParams(transferCCs, []);
            await this.sendTransferRequest(params);
        }
            } catch (error) {
                console.error(error);
            } finally {
                window.hideLoading();
            }
        },

        isValidTransfer() {
            return (this.transferTo && this.transferTo.id) || (this.transferToMulti && this.transferToMulti.length > 1);
        },

        getTransferTos() {
            if (this.transferTo && this.transferTo.id) {
                return [this.transferTo];
            } else {
                return this.transferToMulti.filter(item => item !== this.transferToMulti[0]);
            }
        },

        getTransferCCs() {
            return this.transferCC ? this.transferCC.filter(item => item !== this.transferCC[0]) : [];
        },

        buildParams(forwardTo, forwardCC) {
            return {
                TransferId: this.transferId,
                DocumentId: this.documentId,
                ForwardTo: forwardTo,
                ForwardCC: forwardCC,
                Purpose: this.purpose.id,
                DueDate: this.dueDate,
                Note: this.note,
                FollowUp: this.followup,
                SecretForward: this.secretForward,
                DelegationId: this.delegationId,
                IsSecretNote: this.isSecretNote,
                WorkflowId: this.workflowId
            };
        },

        async sendTransferRequest(params) {
            try {
                const res = await axios.post(constants.baseApiUrl + 'Transfer/TransferDocument', params);
                if (res.data.item1 === 'CantTransfer') {
                    window.showAlert('res_Msgs_CantTransfer', 'success');
                } else {
                    window.showAlert(this.successMessage, 'success');
                    this.closeDialog();
                }
            } catch (error) {
                console.error(error);
            } finally {
                window.hideLoading();
            }
        },

        showWarning(message) {
            window.hideLoading();
            window.showAlert(message, 'warning');
        },

        clearForm() 
        {
            // this.rejected = false
            // this.disableRecipient = false
            this.note = ''
            this.SelectedSignAsOption= false
            // this.transferTo = {}
            // this.transferCC = []
            // this.sign = false
            this.canSignByImpersonation=false
            this.dueDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
            this.followup = false
            this.secretForward = false
            this.pinCode = ''
            if(this.sign)
                this.pinValidate = false
            // this.checkForAttachmentsUploadMultiApproval = false
            this.numberOfAttachmentsRemainingToUpload = 0
            this.isSecretNote = false
            try 
            {
                if (this.defaultDueDate) 
                {
                    const defaultDueDateWithoutTime = utils.formatDateFromString(this.defaultDueDate);
                    const currentDateWithoutTime = new Date();

                    defaultDueDateWithoutTime.setHours(0, 0, 0, 0);
                    currentDateWithoutTime.setHours(0, 0, 0, 0);

                    if (defaultDueDateWithoutTime >= currentDateWithoutTime)
                        this.dueDate = this.defaultDueDate;
                }

                // clearing the wsiwyg editor
                document.getElementById('editor').innerText = ''
                var arrElements = document.all['editor'];
                for (let index = 0; index < arrElements.length; index++) 
                {
                    arrElements[index].innerText = '';
                }
            }
            catch (e) { }
        },
        cancelDialog() 
        {
            this.clearForm()
            this.$emit('cancelCorrespondenceDocument');
        },
        removeItem(itemId) 
        {
            this.transferToMulti = this.transferToMulti.filter(item => item.id !== itemId);
        },
        transferToMultipleSelectedChange(items) 
        {
            this.transferToMulti = this.handleFirstElement(items, {name: 'temp', isTemp: true}); 
        },
        transferToSelectedChange(item)
        { 
            this.transferTo = item;
        },
        ccSelectedChange(items)
        {
            this.transferCC = this.handleFirstElement(items, {name: 'temp', isTemp: true});
        },
        handleFirstElement(data, tempItem)
        {
            if (data.length > 0) 
            {
                var shouldAddTemp = true;
                for (var i = 0; i<data.length; i++)
                {
                    if (data[i].isTemp || data[i].id == undefined || data[i].id == null)
                    {
                        shouldAddTemp = false;
                        break;
                    }
                }

                if (shouldAddTemp) 
                {
                    if (tempItem == undefined || tempItem == null)
                    {
                        tempItem = {isTemp: true, name: 'temp'};
                    }
                    data = [tempItem, ...data];
                } 
                else if(data.length == 1)
                {
                    data = [];
                }
            }
            return data;
        },
        CheckSignatureImpersonation()
        {
            axios.get(constants.baseApiUrl + 'Delegation/CanImpersonatedSign?delegationId=' + this.delegationId)
                .then(res => { this.canSignByImpersonation = res.data })
                .catch(err => console.log(err));
        },
        closeMultiTransferForm()
        {
            this.multiTransferFormDialog = false;
            this.closeDialog();
        },
        onFormLoaded()
        {  
       
            this.clearForm();
            this.purpose_items = [...this.allTransferPurposes];
             console.log("this.purpose_itemsonFormLoaded"+  this.purpose_items)
            var user = JSON.parse(sessionStorage.getItem("user"));
            
            var loginUserId = user.profile.Id


            var docCreatedBy=this.documentCreatedByUserId
             console.log(this.purpose.id)
             // if(((loginUserId == this.documentCreatedByUserId)&&this.transferId==0)&& this.categoryId==6)
             // {
                if(((loginUserId == this.documentCreatedByUserId)||this.transferId==0 ||this.transferId==null)&& this.categoryId==6)
                {
               
                //const filterValues = ['For Review', 'For Signature']; 
                const filterValues = [7, 8]; 
               
               

                const filteredPurposes = this.purpose_items.filter(purpose => filterValues.includes(purpose.id)); 
                console.log("filteredPurposes"+ filteredPurposes)
                 this.purpose_items =filteredPurposes
              }
              else if(this.categoryId==6 &&  this.purpose.id==11)
              { 
                //&& this.purpose.name=='For Approved'
                this.GetInitiator(this.documentId)
                //const filterValues = ['Approved', 'Rejected'];
                 const filterValues = [11, 12];

                 const filteredPurposes = this.purpose_items.filter(purpose => filterValues.includes(purpose.id));
                 this.purpose_items =filteredPurposes

              }
      
            this.language = localStorage.getItem('lang')
            if (this.transferFormType == 'Endorse')
            {
                this.disableRecipient = true
                this.canSendSecretTransfer = false
                this.disableAdvancedTransfer = true
                this.disableAdvancedTransfersBeforeIsSigned = true
            }
            else
            {
                this.disableRecipient = false
                this.canSendSecretTransfer = constants.userActions.features.some(x=>x.name.toLowerCase() == constants.actionsEnum.features.SecretTransfer.key)
                this.disableAdvancedTransfer = false
                this.disableAdvancedTransfersBeforeIsSigned = window.disableAdvancedTransfersBeforeIsSigned
            }
        },
    },
    mounted() 
    {   
        this.onFormLoaded()
        this.isUAEPassEnabledForTemplate = constants.isUAEPassEnabledTemplate ;
        this.isEsealEnabledForTemplate = constants.isEsealEnabledTemplate ;
    },
    watch: 
    {
        mom_purpose_items(newVal,oldVal){

             if (newVal != oldVal) 
            {   
                if (newVal.length=2)
                   this.purpose_items=this.mom_purpose_items;
            }

        },
   
        sign() 
        {
            this.pinValidate = !this.sign
            if (this.delegationId > 0)
                this.CheckSignatureImpersonation()
        },
        transferFormDialog(newVal, oldVal) 
        {
            if (newVal != oldVal) 
            {
                if (newVal == true)
                    this.onFormLoaded()
                else
                    this.clearForm()
            }
        },
        transferTo() 
        {
            this.Forwarded = []

            if (this.transferTo != null && this.transferTo != undefined && this.transferTo.id != null && this.transferTo.id != undefined) 
            {
                axios.get(constants.baseApiUrl + 'Transfer/GetAutoForwardRules?ForwardTo=' + this.transferTo.id + '&isUser=' + this.transferTo.isUser + '&delegationId=' + this.delegationId)
                    .then(res => this.Forwarded = res.data)
                    .catch(err => console.log(err));
            }
            else
                this.Forwarded = []
           if (this.transferId != null && this.transferId != undefined&& this.transferId != ',0')
            {
            axios.get(constants.baseApiUrl + 'Transfer/GetNumberOfAttachmentsToUploadForMultiApproval?transferId=' + this.transferId)
                .then(res => this.numberOfAttachmentsRemainingToUpload = res.data)
            }
        }
    },
    computed: mapGetters(['allTransferPurposes']),
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.radio-label { display: inline-block; margin-right: 10px; }
.radio-input { margin-right: 5px; }
.ad__box { margin-left: 9px; margin-right: 9px; padding-top: 6px; }
.ad__text { margin-bottom: 5px; }
.ad__text__bold { font-weight: bold; }
.ad__box p { margin-bottom: 0px; }
.multiselect__option--highlight .v-avatar { color: #205CDF !important;}
.multiselect__select { display: none !important; }
/* .multiselect__option { padding-top: 5px; padding-bottom: 0px;} */
</style> 